import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue')
        },
        {
            path: '/support',
            name: 'support',
            component: () => import('./views/Support.vue')
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('./views/About.vue')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('./views/Contact.vue')
        },
        {
            path: '/jobs',
            name: 'jobs',
            component: () => import('./views/Jobs.vue')
        },
        {
            path: '/business',
            name: 'business',
            component: () => import('./views/Business.vue')
        },
        {
            path: '/product/r2',
            name: 'product-r2',
            component: () => import('./views/product/R2.vue')
        },
        {
            path: '/product/c3',
            name: 'product-c3',
            component: () => import('./views/product/C3.vue')
        },
        {
            path: '/product/n1',
            name: 'product-n1',
            component: () => import('./views/product/N1.vue')
        },
    ]
})
